import { render, staticRenderFns } from "./ReplaceTeacherDialog.vue?vue&type=template&id=2c02504e&scoped=true&"
import script from "./ReplaceTeacherDialog.vue?vue&type=script&lang=js&"
export * from "./ReplaceTeacherDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceTeacherDialog.vue?vue&type=style&index=0&id=2c02504e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02504e",
  null
  
)

export default component.exports